import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { ArrowBackIos, ArrowForwardIos, ArrowRight, Business, Dashboard, Logout, Person, Receipt, } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import * as statuses from 'services/store/states';
import styles from './Navigation.module.css';
export default function Navigation(_a) {
    var status = _a.status, societies = _a.societies, statusSocieties = _a.statusSocieties, actions = _a.actions;
    var _b = useState(window.innerWidth <= 768), hide = _b[0], setHide = _b[1];
    var t = useTranslation().t;
    useEffect(function () {
        if (status === statuses.IDLE) {
            actions.fetchUserInfo();
        }
        if (statusSocieties === statuses.IDLE) {
            actions.fetchEntities();
        }
    }, []);
    useEffect(function () {
        var handleResize = function () {
            if (window.innerWidth >= 768) {
                setHide(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    var logout = function () {
        window.sessionStorage.clear();
        window.localStorage.clear();
        window.location.assign("https://".concat(process.env.REACT_APP_DEBUG ? 'dev-' : '', "auth.ayomi.fr/disconnect"));
    };
    if (status === statuses.FAIL) {
        return null;
    }
    return (_jsxs("div", { className: styles.sidebar, children: [_jsxs("nav", { className: "".concat(styles.mobile, " ").concat((hide) ? styles.hide : styles.navigation), children: [_jsx("p", { className: styles.logo, children: "AYOMI" }), _jsxs(NavLink, { to: "/", className: function (_a) {
                            var isActive = _a.isActive;
                            return isActive ? "".concat(styles.link, " ").concat(styles.active) : styles.link;
                        }, end: true, children: [_jsxs("span", { children: [_jsx(Dashboard, { className: styles.icon }), t('navigation.overview')] }), _jsx(ArrowRight, { className: styles.arrow })] }), _jsxs(NavLink, { to: "/person", className: function (_a) {
                            var isActive = _a.isActive;
                            return isActive ? "".concat(styles.link, " ").concat(styles.active) : styles.link;
                        }, children: [_jsxs("span", { children: [_jsx(Person, { className: styles.icon }), t('navigation.person')] }), _jsx(ArrowRight, { className: styles.arrow })] }), _jsxs(NavLink, { to: "/invoices", className: function (_a) {
                            var isActive = _a.isActive;
                            return isActive ? "".concat(styles.link, " ").concat(styles.active) : styles.link;
                        }, children: [_jsxs("span", { children: [_jsx(Receipt, { className: styles.icon }), t('navigation.invoices')] }), _jsx(ArrowRight, { className: styles.arrow })] }), (societies && societies.length > 0)
                        && (_jsxs(NavLink, { to: "/society", className: function (_a) {
                                var isActive = _a.isActive;
                                return isActive ? "".concat(styles.link, " ").concat(styles.active) : styles.link;
                            }, children: [_jsxs("span", { children: [_jsx(Business, { className: styles.icon }), t('navigation.society')] }), _jsx(ArrowRight, { className: styles.arrow })] })), _jsxs("button", { type: "button", className: "".concat(styles.logout, " ").concat(styles.link), onClick: logout, children: [_jsx(Logout, { className: styles.icon }), t('navigation.logout')] })] }), _jsx("button", { type: "button", onClick: function () { return setHide(function (state) { return !state; }); }, className: "".concat(styles.button, " ").concat((hide) ? styles.close : styles.open), children: (hide) ? _jsx(ArrowForwardIos, {}) : _jsx(ArrowBackIos, {}) })] }));
}
